import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import axios from "axios";
const ReusablePackagingSelect = ({ tenantId, disabled = false, allowClear = false, placeholder = "Select a reusable packaging", value, style, onChange, onReusablePackagingSelected }) => {
    const [reusablePackagings, setReusablePackagings] = useState([]);
    const [selectOptions, setSelectOptions] = useState([]);
    useEffect(() => {
        if (tenantId) {
            loadReusablePackagings();
        }
    }, [tenantId]);
    const loadReusablePackagings = () => {
        axios.get("/admin/v1/reusable-packagings?limit=999", { 'headers': { 'FilterTenantId': tenantId } })
            .then(response => {
            const reusablePackagings = response.data.results;
            const selectOptions = reusablePackagings.map(reusablePackaging => {
                return {
                    label: reusablePackaging.name,
                    value: reusablePackaging.id
                };
            });
            setReusablePackagings(reusablePackagings);
            setSelectOptions(selectOptions);
            if (value) {
                fireReusablePackagingSelected(value);
            }
        });
    };
    const onSelectChanged = (val) => {
        onChange && onChange(val);
        fireReusablePackagingSelected(val);
    };
    const fireReusablePackagingSelected = (val) => {
        if (onReusablePackagingSelected) {
            const selectedReusablePackaging = reusablePackagings.find(rp => rp.id == val);
            if (selectedReusablePackaging) {
                onReusablePackagingSelected(selectedReusablePackaging);
            }
        }
    };
    return (_jsx(Select, { disabled: disabled, allowClear: allowClear, placeholder: placeholder, style: style, onChange: onSelectChanged, value: value, showSearch: {
            optionFilterProp: ['label']
        }, options: selectOptions }));
};
export default ReusablePackagingSelect;
